import { render, staticRenderFns } from "./ApprovalClaimListItem.vue?vue&type=template&id=465f7ffc"
import script from "./ApprovalClaimListItem.vue?vue&type=script&lang=js"
export * from "./ApprovalClaimListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports